import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=20199ca7"
import script from "./profiles.vue?vue&type=script&lang=js"
export * from "./profiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports